export default {
  email: 'Email',
  invalidError: 'Email or password are incorrect.',
  send: 'Send email'
};



// WEBPACK FOOTER //
// ./src/components/forms/reset-form/ResetForm.messages.js